module.exports = __webpack_public_path__ + "img/one_7.4b14bfda.png";